import {Component, Input, OnInit} from '@angular/core';
import {EventService} from "../../../../services/event.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import { ImageService } from '../../../../services/image.service';
import {Angulartics2} from "angulartics2";

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
    @Input() currentImage: any;
    @Input() isTeam: boolean = false;
    @Input() saveBtnLabel: string = 'Save';
    public images: any = [];

    constructor(
        private eventService: EventService,
        public activeModal: NgbActiveModal,
        private imageService: ImageService,
        private angulartics2: Angulartics2
    ) {}

    ngOnInit() {
        let imgs = null;
        if (this.isTeam) {
            // for now images are owned by constituent
            imgs = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.constituentImageLibraries;
        } else {
            imgs = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.constituentImageLibraries;
        }
        this.images = imgs.map(o => {
            o = JSON.parse(JSON.stringify(o));
            o.imagePath = this.imageService.formatUrl(o.imagePath);
            return o;
        }).sort((a,b) => {
            return b.constituentImageLibraryId - a.constituentImageLibraryId;
        });
    }

    selectImage(image: any) {
        this.currentImage = image;
    }

    save() {
        this.activeModal.close(this.currentImage);
        this.angulartics2.eventTrack.next({
            action: 'Change Image',
            properties: {category: 'Profile'}
        });
    }
}
